const apiClient = require('@/api/client.js')
import { ToastProgrammatic as Toast } from 'buefy'

export default {

  getBatchRoute(batch_id, callback){

    if (!batch_id){
      return callback('Invalid batch id')
    }

    return apiClient.get('/job/batch/' + batch_id + '/route', null, callback);


  },

  getJobs(batch_id, callback){

    if (!batch_id){
      return callback('Invalid batch id')
    }

    apiClient.get('/job/batch', {batch_id}, callback);

  }

}



// WEBPACK FOOTER //
// ./src/components/job/batch/service.js